import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { MuiInputDirective } from '../../input/mui-input.directive';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { MuiColor } from '../../../utility';
import { MuiIconFont } from '../../../icon';

let nextUniqueId = 0;

@Component({
  selector: 'mui-form-field-submit',
  templateUrl: './mui-form-field-submit.component.html',
  styleUrls: ['./mui-form-field-submit.component.scss']
})
/* eslint-disable @angular-eslint/no-output-on-prefix */
export class MuiFormFieldSubmit {
  @Input()
  color: MuiColor | string = MuiColor.DEFAULT;

  @Input()
  icon = 'check';

  @Input()
  iconFont: MuiIconFont | string = MuiIconFont.FONTAWESOME;

  @Input()
  saving = false;

  // submit is already in use for the public instance method
  @Output()
  onSubmit = new EventEmitter<any>();

  @Input()
  get disabled(): boolean {
    return this._disabled || this.saving || this.hasError;
  }

  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
  }

  @HostBinding('hidden')
  get hidden(): boolean {
    if (this.muiInput && this.muiInput.ngControl) {
      return this.muiInput.ngControl.pristine || this.muiInput.invalid;
    } else {
      return false;
    }
  }

  muiInput: MuiInputDirective | null = null;
  protected _disabled = false;

  get id(): string {
    return this.muiInput ? this.muiInput.id + '-submit' : this._uid;
  }

  get hasError(): boolean {
    return this.muiInput ? this.muiInput.invalid : false;
  }

  protected _uid = `mui-input-submit-${nextUniqueId++}`;

  submit(): void {
    if (this.muiInput) {
      const val = this.muiInput.value;
      this.onSubmit.emit(val);
    } else {
      console.error('MuiFormFieldSubmitComponent: Internal _control property is not set. Cannot determine control value.');
    }
  }
}
